import * as React from "react"
import type { IconProps } from "../types"
const Typescript = React.forwardRef<SVGSVGElement, Omit<IconProps, "color">>(
  (props, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          fill="#3178C6"
          d="M11.25.75h-7.5a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3v-7.5a3 3 0 0 0-3-3"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M8.462 10.656v1.375q.312.172.738.258t.898.086q.46 0 .874-.095a2.1 2.1 0 0 0 .727-.311q.312-.217.494-.568.182-.35.182-.866 0-.375-.104-.655a1.6 1.6 0 0 0-.3-.501 2.2 2.2 0 0 0-.47-.394 5 5 0 0 0-.619-.328 8 8 0 0 1-.452-.217 2.3 2.3 0 0 1-.34-.215.9.9 0 0 1-.216-.233.5.5 0 0 1-.076-.277.5.5 0 0 1 .068-.256.6.6 0 0 1 .192-.195 1 1 0 0 1 .304-.127q.18-.045.4-.045.16 0 .338.026a2.5 2.5 0 0 1 .709.215q.17.081.314.189V6.236a3 3 0 0 0-.638-.178A5 5 0 0 0 10.69 6q-.456 0-.864.105t-.718.33q-.31.222-.49.569-.18.345-.18.827 0 .615.33 1.05.33.434 1.002.734.264.117.492.228.229.112.394.232.166.12.262.262a.56.56 0 0 1 .037.57.56.56 0 0 1-.183.198 1 1 0 0 1-.304.13 1.7 1.7 0 0 1-.426.048q-.416 0-.824-.157a2.4 2.4 0 0 1-.756-.47M6.31 7.265h1.642V6.137H3.375v1.13h1.634v5.026h1.3z"
          clipRule="evenodd"
        />
      </svg>
    )
  }
)
Typescript.displayName = "Typescript"
export default Typescript
